var module = 'signin', name = 'signin/config/locales/fr_CA.json', content = {
  "signin": {
    "titles": {
      "my_account": "Mon compte",
      "why.hin": "Pourquoi dois-je fournir ma date de naissance et mon numéro d'assurance maladie?",
      "why.phin": "Pourquoi dois-je fournir ma date de naissance et mon numéro d'identification personnel?",
      "why.email": "Pourquoi une adresse courriel est-elle requise?",
      "no_account_no_new": "Désolé! Aucun dossier ne correspond aux informations fournies.",
      "linked_patient_error": "Désolé! Il n'est pas possible de lier cette personne avec votre compte.",
      "registration.success": "Félicitations! Votre nouveau compte est presque prêt.",
      "already_account_mismatch": "Vos informations personnelles nous indiquent que vous avez un dossier dans notre clinique.",
      "already_account_match": "Votre adresse courriel est déjà associée à un compte ailleurs dans le réseau :",
      "good_news": "Bonne nouvelle! Vous êtes déjà inscrit.",
      "create_password": "Créer un mot de passe",
      "password": "Mot de passe",
      "expired_activation": "Le lien d'activation est malheureusement expiré.",
      "already_used_email": "Désolé! Cette adresse courriel est déjà associée à un dossier à la clinique.",
      "alredy_registered": "Vous êtes déjà inscrit.",
      "forgotten_password": "Vous avez oublié votre mot de passe?",
      "reset_email_sent": "Consultez votre boîte courriel!",
      "no_account_found": "Désolé! Impossible de trouver un compte avec l’adresse courriel fournie.",
      "expired_reset": "Désolé, ce lien est expiré.",
      "forgot_password": "Vous avez oublié votre mot de passe?",
      "reset_password": "Veuillez entrer un nouveau mot de passe."
    },
    "labels": {
      "empty_state": "Sélectionner",
      "gender": "Genre",
      "first_name": "Prénom",
      "last_name": "Nom",
      "birthdate": "Date de naissance",
      "city": "Ville",
      "phone": "Numéro de téléphone",
      "hin": "Numéro d'assurance maladie",
      "phin": "Numéro d'identification personnel",
      "hin_expiration": "Date d'expiration",
      "email": "Adresse courriel",
      "email_confirmed_label": "Saisir votre adresse courriel complète",
      "password": "Mot de passe",
      "password_confirmation": "Confirmer le mot de passe",
      "user_agreement": "J'ai lu et j'accepte l'<a href=\"/patient-agreement?locale=fr_CA\" target=\"_blank\">entente d'utilisation</a>",
      "day": "JJ",
      "month": "Sélectionner",
      "month_full": "Mois",
      "year_full": "Année",
      "year": "AAAA"
    },
    "options": {
      "gender": {
        "female": "Féminin",
        "male": "Masculin",
        "other": "Autre"
      }
    },
    "messages": {
      "why.defaultHin": "Ces informations sont essentielles pour valider votre identité et associer votre compte au bon dossier. Si vous n’avez pas de NAM, veuillez contacter la clinique ${clinicNumber} pour créer votre dossier et votre compte.",
      "why.phn": "Ces informations sont essentielles pour valider votre identité et associer votre compte au bon dossier. Si vous n’avez pas de NIP, veuillez contacter la clinique ${clinicNumber} pour créer votre dossier et votre compte.",
      "why.manitobaPhin": "Ces informations sont essentielles pour valider votre identité et associer votre compte au bon dossier. Si vous n’avez pas de NIP, veuillez contacter la clinique ${clinicNumber} pour créer votre dossier et votre compte.",
      "why.hin": "Ces informations sont essentielles pour valider votre identité et associer votre compte au bon dossier.",
      "why.email": "Votre courriel est utilisé pour vous connecter à votre compte. Il sera également utilisé pour partager des rappels et d'autres informations sur vos rendez-vous.",
      "why.hospital_booking_email": "L'adresse courriel est utilisée pour vous connecter à votre compte. Assurez-vous donc de choisir une adresse courriel à laquelle vous avez facilement accès.",
      "no_account_no_new": "Veuillez prendre note que la clinique n'accepte pas de nouveaux patients. Toutefois, si vous croyez avoir un dossier à la clinique, veuillez communiquer avec nous au",
      "linked_patient.already_linked": "La personne est déjà associée à un autre compte.",
      "linked_patient.already_confirmed": "Il est impossible d’associer cette personne, car elle gère déjà son propre compte.",
      "linked_patient.child_not_found": "La personne n'a pas été trouvée.",
      "linked_patient.cant_link_self": "Vous ne pouvez pas associer votre propre compte.",
      "registration.success": "Vous recevrez un courriel d'activation à l'adresse que vous nous avez fournie. L'activation est la dernière étape avant que vous puissiez prendre un rendez-vous en ligne!",
      "registration.hospital_booking_success": "Vous recevrez un courriel d'activation à l'adresse que vous nous avez fournie. L'activation est la dernière étape avant que vous puissiez consulter vos rendez-vous en ligne!",
      "already_account_mismatch": "Toutefois l'adresse courriel que nous avons n'est pas la même que celle indiquée dans le formulaire ci-contre. Veuillez sélectionner l'adresse que vous désirez conserver pour vous connecter à votre compte.",
      "already_account_match": "Afin de faciliter l'accès à la plateforme, veuillez utiliser le même mot de passe pour vous connecter.",
      "good_news": "Connectez-vous pour prendre un rendez-vous.",
      "hospital_booking_good_news": "Connectez-vous pour consulter vos rendez-vous.",
      "password": "Le mot de passe doit contenir au minimum 8 caractères, dont au moins une majuscule et un chiffre.",
      "password_mismatch": "Les mots de passe ne correspondent pas.",
      "expired_activation": "Veuillez créer un nouveau compte et assurez-vous de l'activer aussitôt pour accéder à la prise de rendez-vous en ligne.",
      "already_used_email": "Si vous désirez ajouter un membre de votre famille à votre compte, communiquez avec nous au <strong>{{phone}}</strong>",
      "alredy_registered": "Connectez-vous pour prendre un rendez-vous.",
      "reset_password": "Veuillez inscrire l'adresse courriel utilisée pour accéder à votre compte. Vous recevrez un courriel avec la marche à suivre pour créer un nouveau mot de passe.",
      "reset_email_sent": "Un lien pour créer un nouveau mot de passe vous a été envoyé.",
      "no_account_found": "Peut-être avez-vous utilisé une autre adresse lors de votre inscription?",
      "expired_reset": "Veuillez inscrire l'adresse courriel utilisée pour accéder à votre compte pour recommencer."
    },
    "actions": {
      "create": "Créer mon compte",
      "connect": "Me connecter",
      "cancel": "Annuler",
      "continue": "Continuer",
      "forgotten_password": "Vous avez oublié votre mot de passe?",
      "return_login_page": "Retourner à la page de connexion"
    },
    "notices": {
      "family_accounts": "Sachez qu'il est possible de regrouper dans un même compte plusieurs membres d'une famille.<br>Visitez la section Gérer mon profil pour plus d’information."
    },
    "errors": {
      "gender.required":"Veuillez sélectionner un genre.",
      "first_name.required": "Veuillez entrer votre prénom.",
      "first_name.maxlength": "Le champ ne peut contenir plus de {{value}} caractères.",
      "last_name.required": "Veuillez entrer votre nom.",
      "last_name.maxlength": "Le champ ne peut contenir plus de {{value}} caractères.",
      "birthdate.required": "Veuillez entrer une date de naissance.",
      "city.required": "Veuillez entrer votre ville.",
      "city.maxlength": "Le champ ne peut contenir plus de {{value}} caractères.",
      "phone.required": "Veuillez entrer un numéro de téléphone valide.",
      "phone.maxlength": "Le champ ne peut contenir plus de {{value}} caractères.",
      "hin.required": "Veuillez entrer votre numéro d'assurance maladie.",
      "hin.invalid": "Nous avons du mal à trouver votre dossier. Veuillez nous appeler pour obtenir de l'aide.",
      "phin.required": "Veuillez entrer votre numéro d'identification personnel.",
      "phin.number_only": "Le numéro d'identification personnel doit être constitué de chiffres uniquement",
      "phin.minlength": "Le numéro d'identification personnel doit avoir 9 chiffres",
      "hin.alreadyTaken": "Nous avons du mal à trouver votre dossier. Veuillez nous appeler pour obtenir de l'aide.",
      "hin_expiration.required": "Veuillez entrer une date d'expiration.",
      "hin_expiration.invalid": "Veuillez entrer une date d'expiration valide.",
      "email.required": "Veuillez entrer votre adresse courriel.",
      "email.invalid": "Veuillez entrer une adresse courriel valide.",
      "email.already_used": "Cette adresse courriel est déjà utilisée.",
      "email.dont_exist": "Cette adresse courriel n’existe pas dans notre système. ",
      "email.alreadyTaken": "Vous ne pouvez utiliser cette adresse courriel puisqu'elle existe déjà dans notre système.<br><br>Si vous désirez créer un compte pour votre enfant ou une autre personne, vous pouvez le faire à partir de votre propre compte. Vous n'avez qu'à utiliser l'option \"Gérer mon profil\", du menu supérieur droit.",
      "password.activated": "Votre compte est déjà activé.",
      "password.required": "Vous avez oublié de mettre un mot de passe.",
      "password.minlength": "Votre mot de passe doit avoir plus de {{value}} caractères.",
      "password.maxlength": "Votre mot de passe doit avoir moins de {{value}} caractères.",
      "password.invalid": "Votre mot de passe doit contenir au moins une majuscule et un chiffre.",
      "confirm_password.required": "Vous avez oublié de confirmer votre mot de passe.",
      "confirm_password.unmatch": "Vos mots de passe ne correspondent pas.",
      "user_agreement.required": "Vous devez accepter les conditions d'utilisation.",
      "date.invalid": "Veuillez entrer une date valide."
    },
    "delegation_form": {
      "title": "Informations de la personne associée (optionnel)",
      "linked": {
        "title": "Personne associée ?",
        "description": "Vous pouvez fournir les informations de la personne pour qui vous allez prendre rendez-vous (enfant, personne à charge, etc.)."
      },
      "linked_multiple": {
        "title": "Vous avez plus d’une personne à associer ?",
        "description": "Une fois l’inscription complétée, vous pourrez associer d’autres personnes à votre compte."
      },
      "same_contact_info": "Mêmes coordonnées que moi"
    }
  },
  "login": {
    "title": "Prise de rendez-vous en ligne",
    "hospital_booking_title": "Portail Patient",
    "subtitle": "Vous êtes déjà inscrit?",
    "instruction": "Connectez-vous pour prendre un rendez-vous.",
    "email_label": "Nom d'utilisateur",
    "password_label": "Mot de passe",
    "login_button_message": "Me connecter",
    "error": {
      "required": "Champ requis",
      "pattern": "Format de champ incorrect",
      "bad_credentials": "Votre courriel ou votre mot de passe est incorrect",
      "patient_not_created": "Tout d'abord, vous devez créer votre compte avec cette clinique",
      "link_no_longer_valid": "Le lien fourni n'est plus valide"
    },
    "side.title": "Pas encore inscrit?",
    "messages.accept_new": "La clinique est heureuse d'accepter de nouveaux patients. Créez votre compte dès maintenant pour avoir accès à la prise de rendez-vous en ligne!",
    "messages.refuse_new": "Veuillez prendre note que la clinique n'accepte pas de nouveaux patients. Vous devez avoir un dossier à la clinique pour vous créer un compte et prendre un rendez-vous en ligne.",
    "messages.hospital_booking_sign_up": "Créez votre compte dès maintenant pour consulter l'historique de vos rendez-vous et vos rendez-vous à venir!",
    "actions.create": "Créer mon compte"
  },
  "activation": {
    "title": "Créer un mot de passe ",
    "legal_notice_agree_checkbox": "J'ai lu et j'accepte <a ui-sref=\"patient_agreement({locale: activationForm.$translate.use()})\" target=\"_blank\">l'entente d'utilisation</a>",
    "password_creation_title": "Vous utiliserez l'adresse courriel inscrite à votre dossier et un mot de passe pour vous connecter.",
    "choose_password_label": "Mot de passe",
    "confirm_password_label": "Confirmer le mot de passe",
    "password_restricted_label": "Le mot de passe doit contenir au minimum 8 caractères, dont au moins une majuscule et un chiffre.",
    "validation_button_message": "Me connecter",
    "error": {
      "forgot_to_enter_password": "Vous avez oublié de mettre un mot de passe",
      "password_too_short": "Votre mot de passe doit avoir plus de 8 caractères",
      "password_too_long": "Votre mot de passe doit avoir moins de 256 caractères",
      "password_invalid": "Votre mot de passe doit contenir au moins une majuscule et un chiffre",
      "forgot_to_confirm_password": "Vous avez oublié de confirmer votre mot de passe",
      "password_not_match": "Vos mots de passe ne correspondent pas",
      "notice_not_accepted": "Vous devez accepter les conditions d'utilisation"
    }
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./signin/config/locales/fr_CA.json
// module id = 788
// module chunks = 0